export const MULTIPLE_TAG_USAGE = 'remote-config.multiple-tag-usage'
export const USING_INCLUDE_AND_EXCLUDE_RULE_IDS =
  'remote-config.using-include-and-exclude-rule-ids'
export const UNKNOWN_TAGS = 'remote-config.unknown-tags'
export const NO_CONFIG_FOR_ASSET_TYPE = 'remote-config.no-config-for-asset-type'
export const UNKNOWN_DETECTORS = 'remote-config.unknown-detectors'
